import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MessageCircle, X } from 'lucide-react';
import WALink from './WALink';

// Static animation config — extracted out of render to avoid creating fresh refs each render.
const TOOLTIP_INITIAL = { opacity: 0, scale: 0.8, y: 10 };
const TOOLTIP_ANIMATE = { opacity: 1, scale: 1, y: 0 };
const TOOLTIP_EXIT = { opacity: 0, scale: 0.8, y: 10 };
const TOOLTIP_TRANSITION = { duration: 0.4, ease: [0.22, 1, 0.36, 1] };

export default function WhatsAppFloating() {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const showTimer = setTimeout(() => setVisible(true), 3000);
    const hideTimer = setTimeout(() => setVisible(false), 13000);
    return () => { clearTimeout(showTimer); clearTimeout(hideTimer); };
    // Mount-only timers; `setVisible` is a stable useState setter.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (dismissed) return null;

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-3">
      {/* Tooltip bubble */}
      <AnimatePresence>
        {visible && (
          <motion.div
            initial={TOOLTIP_INITIAL}
            animate={TOOLTIP_ANIMATE}
            exit={TOOLTIP_EXIT}
            transition={TOOLTIP_TRANSITION}
            className="relative bg-[#F5F0E8] border border-[#D5CCBF] shadow-lg p-4 max-w-[220px] rounded-sm"
          >
            <button
              onClick={() => setDismissed(true)}
              className="absolute top-2 right-2 text-[#5C6B5C] hover:text-[#2D4A2D]"
              data-testid="wa-tooltip-close"
            >
              <X size={14} strokeWidth={1.5} />
            </button>
            <p className="font-sans font-medium text-[#2D4A2D] text-xs mb-1">Join 500+ women!</p>
            <p className="font-sans font-light text-[#5C6B5C] text-xs leading-snug">
              WhatsApp community join karo — exclusive access milegi
            </p>
            {/* Arrow */}
            <div className="absolute -bottom-2 right-8 w-4 h-4 bg-[#F5F0E8] border-b border-r border-[#D5CCBF] rotate-45" />
          </motion.div>
        )}
      </AnimatePresence>

      {/* Main button */}
      <WALink
        source="floating_button"
        data-testid="whatsapp-floating-btn"
        className="w-14 h-14 bg-[#2D4A2D] text-[#F5F0E8] rounded-full flex items-center justify-center shadow-lg wa-pulse hover:scale-110 transition-transform duration-200"
        onClick={() => setVisible(false)}
      >
        <MessageCircle size={26} strokeWidth={1.5} />
      </WALink>
    </div>
  );
}
